import { render, staticRenderFns } from "./swiperCoach.vue?vue&type=template&id=735a4c4c&scoped=true&"
import script from "./swiperCoach.vue?vue&type=script&lang=js&"
export * from "./swiperCoach.vue?vue&type=script&lang=js&"
import style0 from "./swiperCoach.vue?vue&type=style&index=0&id=735a4c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735a4c4c",
  null
  
)

export default component.exports